export const BASE_API_URL = process.env.REACT_APP_BASE_URL;
export const CM_CLOUD_API_URL = process.env.REACT_APP_CM_CLOUD_URL;

export const MUI_LICENSE_KEY = process.env.REACT_APP_MUI_LICENSE_KEY || '';
export const MIX_PANEL_PROJECT_TOKEN = process.env.REACT_APP_MIX_PANEL_PROJECT_TOKEN || '';

export const CUSTOMER_SUPPORT_ORG_ID = "org_900000000000000000000000" // Static customer support org Id
export const CRIBMASTER_SALES_ID = "org_900000000000000000000001" // Sales Org Id 